<template lang="html">
  <v-app light>
    <v-layout
      v-if="loading"
      justify-center
      align-center
      class="loading-indicator"
    >
      <v-progress-circular
        indeterminate
        :size="70"
        :width="7"
      />
    </v-layout>
    <v-container v-else>
      <v-row>
        <v-col cols="12">
          <h2>Формирование отчета о показании счетчиков на указанную дату</h2>
        </v-col>
        <v-col cols="auto">
          <v-menu
            :close-on-content-click="false"
            content-class="report-tree"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                class="report-tree-btn"
              >Выбрать объекты</v-btn>
            </template>
            <report-tree-node
              :is-root="true"
              :initial-represents="[]"
              :initial-all-points="[]"
              :represent-points="[]"
              :represents-select-type="representsSelectType"
              :points-select-type="pointsSelectType"
              :limit-selected-points="false"
              @repr-select="reprSelect"
              @point-select="pointSelect"
              @selected-repr-expand="selectedReprExpand"
            />
          </v-menu>
        </v-col>
        <v-col>
          <v-menu
            v-model="menuDate"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-on="on"
                v-model="dateComputed"
                label="Дата"
                prepend-icon="event"
                readonly
              />
            </template>
            <v-date-picker
              v-model="date"
              locale="ru-RU"
              no-title
              @input="menuDate = false"
            />
          </v-menu>
        </v-col>
      </v-row>
      <v-btn
        :disabled="!canGetReport"
        @click="getReport()"
      >
        Сформировать
      </v-btn>
    </v-container>
  </v-app>
</template>

<script type="text/javascript">
import axios from 'axios'
import ReportTreeNode from './ReportTreeNode'

export default {
  components: { ReportTreeNode },
  data () {
    return {
      date: null,
      representsSelectType: 'multiple',
      pointsSelectType: 'multiple',
      representsId: [],
      pointsId: [],
      menuDate: false,
      loading: false
    }
  },
  computed: {
    canGetReport () {
      return this.date && (this.representsId.length || this.pointsId.length)
    },
    dateComputed () {
      return this.formatDate(this.date)
    }
  },
  methods: {
    reprSelect (represent) {
      if (represent.status === 'initial') {
        const key = this.representsId.indexOf(represent.id)
        if (represent.is_selected && key === -1) {
          this.representsId.push(represent.id)
        }
        if (!represent.is_selected && key !== -1) {
          this.representsId.splice(key, 1)
        }
      }
      represent.children.map(child => {
        child.is_selected = represent.is_selected
        this.reprSelect(child)
      })
      represent.points.map(point => {
        point.is_selected = represent.is_selected
        this.pointSelect(point)
      })
    },
    pointSelect (point) {
      const key = this.pointsId.indexOf(point.id)
      if (point.is_selected && key === -1) {
        this.pointsId.push(point.id)
      }
      if (!point.is_selected && key !== -1) {
        this.pointsId.splice(key, 1)
      }
    },
    selectedReprExpand (represent) {
      this.representsId.splice(
        this.representsId.indexOf(represent.id),
        1)
    },
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}-${month}-${year}`
    },
    getReport () {
      this.loading = true
      axios({
        url: '/api/get_report/',
        method: 'POST',
        responseType: 'blob',
        params: {
          'represents_id': JSON.stringify(this.representsId).slice(1, -1),
          'points_id': JSON.stringify(this.pointsId).slice(1, -1),
          'date': this.date,
          'report': 'Form008Report'
        }
      }).then((response) => {
        var blob = new Blob([response.data], { type: 'application/pdf' })
        var link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'report_008.xlsx'
        link.click()
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
.report-tree {
  padding-right: 20px;
  z-index: 1 !important;
  top: 50px !important;
  bottom: 10px;
  background-color: white;
}
.report-tree-btn {
  margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/spa/reports/Report008.vue